import { useCallback } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { getSubmit } from "@ui-seeker/utils"
import { useToast } from "@hooks"
import { reportListData, selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks/index"


export default function useReportTableData() {
	const { showToast } = useToast()
	const isLoadingReportList = useSignal(null)
	const { backendUrl, reportType: pathReportType } = useReportBackendApiPath()

	const getTableContentData = useCallback(() => {
		const params = pathReportType ? {} : { reportType: selectedReportTypeTab.value }
		batch(() => {
			isLoadingReportList.value = true
			reportListData.value = []
			getSubmit(`${backendUrl}/list`, params)
				.then(r => {
					reportListData.value = r
					isLoadingReportList.value = false
				})
				.catch(() => {
					showToast.error()
					isLoadingReportList.value = false
				})
		})
	}, [])

	return {
		isLoadingReportList: isLoadingReportList.value,
		getTableContentData
	}
}